<template>
 
  <v-parallax dark src="../assets/historyBackground.jpg" class="ml-8 mr-8" style="height: 700px;" id="storia">
    <v-row align="center" justify="center" class="d-flex flex-wrap">
      <v-col cols="12">
        <h1 class="font-weight-light w3-serif story-title">
          {{title}}
        </h1>
        <div class="col-md-8 col-sm-12 ml-4">
          <h4 class="subheading font-weight-light w3-serif mb-2 story-text" v-for="paragraph in paragraphes" :key="paragraph">
            {{paragraph}}
          </h4>
        </div>
      </v-col>
    </v-row>
  </v-parallax>
</template>

<script>
  export default {
    name: 'Storia',
    data: () => ({
      title: "La nostra storia",
      paragraphes: {
        firstParagraph: "L’azienda ha iniziato operando a metà anni novanta, come impresa artigiana, nel settore del restauro.",
        secondParagraph: "Successivamente, nel primo decennio del terzo millennio l’attività, incentrata esclusivamente nel territorio regionale e con committenti privati di livello primario, ha acquisito notevoli professionalità nel settore della manutenzione degli edifici condominiali, nel recupero urbano e nel restauro di beni monumentali.",
        thirdParagraph: "L’impresa ha sempre cercato di privilegiare la soddisfazione e la fidelizzazione del cliente, i migliori veicoli promozionali per garantire la continuità e la crescita.",
        fourthParagraph: "Il raggiungimento di questo obiettivo è dimostrato dal fatto che lavora in maniera prevalente con i medesimi committenti privati ai quali offre un servizio che può comprendere in via principale l’esecuzione dei lavori e, quando necessario, anche i servizi relativi all’individuazione delle esigenze del cliente, la progettazione, l’assistenza e l’espletamento delle pratiche per ottenere le autorizzazioni per eseguire l’intervento, nonché la manutenzione e gestione dell’opera.",
        fivethParagraph: "Questa peculiarità dell’impresa ha fatto accrescere un insieme di professionalità complementari tra loro che consentono oramai di offrire un servizio completo.",
        sixthParagraph: "Nel secondo decennio del terzo millennio, l’impresa ha ritenuto opportuno effettuare importanti scelte strategiche per consentirle di essere più competitiva, guadagnare nuovi spazi di mercato e per poter incrementare il fatturato.",
        sevenParagraph: "La prima scelta è stata quella di diversificare la propria attività aprendo anche agli interventi sul patrimonio pubblico di beni vincolati.",
        eigththParagraph: "Contemporaneamente ha implementato l’attività produttiva assumendo nuovo personale, acquisendo ulteriori attrezzature e realizzando con maestranze specializzate i lavori.",
        ninethParagraph: "Con la propria struttura, scelta, formata e selezionata nel tempo, è possibile programmare autonomamente qualsiasi tipo d’intervento, dai complessi immobiliari agli appartamenti privati, ed offrire un servizio completo e professionale che abbraccia tutti gli aspetti legati al complesso settore delle manutenzioni e del restauro degli immobili.",
      }
    }), 
  }
</script>

<style>
  .story-title{
    color: black;
  }
  .story-text{
    color: black;
    font-size: 16px;
  }
</style>
